import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import SearchBox from '../components/Search-box';
import {FormattedMessage} from 'react-intl';
import {navigateBack} from '../services/history';
import {execBI} from '../services/bi-events-manager';
import {openAppMarketHelp, closeAppMarket} from '../services/wrapped-app-market-sdk';
import {popupToggle} from '../actions/popup';
import ALink from '../components/ALink';

const handleMarketHelp = (ev) => {
  ev.preventDefault();
  openAppMarketHelp();
};

const handleMarketClose = (ev) => {
  ev.preventDefault();
  closeAppMarket();
};

const handleBack = (ev) => {
  ev.preventDefault();
  navigateBack();
};


class HeaderSmall extends React.Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    pendingApps: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    menuVisible: PropTypes.bool,
    market: PropTypes.string
  };


  toggleMenu(ev) {
    ev.preventDefault();
    execBI('CATEGORIES_POPUP_LINK_CLICK');
    this.props.dispatch(popupToggle('menu'));
  }

  render() {
    const {pendingApps, location} = this.props;
    const locationQuery = location.query.q || '';
    const homeUrl = this.props.market === 'standalone' ? '/main' : '/';

    return (
      <div className="header-small">

        {location.pathname !== homeUrl ? <div className="header-back">
          <ALink onClick={handleBack} className="typography_t2 header-back-link" to={homeUrl}>
            <span className="header-back-ico"></span>
            <span className="header-back-txt"><FormattedMessage id="navigation.button.back"/></span>
          </ALink>
        </div> : null}

        <div className="header-title">
          <h2><ALink className="typography_t2" to={homeUrl}><FormattedMessage id="main.page.title"/></ALink></h2>
        </div>


        {this.props.market === 'editor' ?
          <div className="header-close">
            <span className="vertical-align-helper"></span>
            <a className="question-ico" href="#" onClick={handleMarketHelp}>?</a>
            <a className="close-ico" href="#" onClick={handleMarketClose}>
              <svg width="25" height="25" viewBox="0 0 25 25">
                <path d="M11.793 12.5L8.146 8.854 7.793 8.5l.707-.707.354.353 3.646 3.647 3.646-3.647.354-.353.707.707-.353.354-3.647 3.646 3.647 3.646.353.354-.707.707-.354-.353-3.646-3.647-3.646 3.647-.354.353-.707-.707.353-.354 3.647-3.646z"></path>
              </svg>
            </a>
          </div> : null }

        <div className={classNames('header-categories', {'menu-visible': this.props.menuVisible})}>
          <a href="#" className="header-categories-button typography_t2" onClick={(ev) => this.toggleMenu(ev)} id="app-market-categories-button">
            <span className="vertical-align-helper"></span>
            <FormattedMessage id="navigation.button.categories"/>
            <span className="header-categories-ico"></span>
            {pendingApps.length ? <span className="categories-notification">{pendingApps.length}</span> : null}
            <span className="header-categories-burger"></span>
          </a>
          <span className="arrow-up"></span>
        </div>

        <SearchBox className="header-search" search={locationQuery} categories={this.props.categories}/>

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pendingApps: state.appsByType.pendingInMarket.items,
    categories: state.categories.menu.items,
    menuVisible: state.popup.type === 'menu',
    market: state.mode.market
  };
}

export default connect(mapStateToProps)(HeaderSmall);



// WEBPACK FOOTER //
// ./containers/Header-small.js